import { localizedNeedLoginPath } from '~/utils/common'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const user = useUser()
  const localePath = useLocalePath()
  router.beforeEach((to, _, next) => {
    // 注册推广码 GLOBAL-357
    const { query } = to
    if (query.promotionCode) {
      const { setPromotionCodeData } = useRegistrationPromotionCode()
      setPromotionCodeData(query.promotionCode as string)
    }
    if (localizedNeedLoginPath().includes(to.path) && !user.value.info?.id) {
      router.replace(localePath('/analysis/products')).then(() => {
        nextTick(() => {
          location.reload()
        })
      })
    }
    else {
      next()
    }
  })
})
